import { Router } from 'express';
import { FlowService } from '../services/flow-service.js';
import { ApiError } from '../types.js';

export const flowRouter = Router();
const flowService = new FlowService();

// 获取所有流程图
flowRouter.get('/', async (req, res, next) => {
  try {
    const flows = await flowService.list();
    res.success(flows);
  } catch (error) {
    next(error);
  }
});

// 获取单个流程图
flowRouter.get('/:id', async (req, res, next) => {
  try {
    const flow = await flowService.get(req.params.id);
    if (!flow) {
      throw new ApiError(404, 'Flow not found');
    }
    res.success(flow);
  } catch (error) {
    next(error);
  }
});

// 保存流程图（创建或更新）
flowRouter.put('/:id', async (req, res, next) => {
  try {
    const { nodes, edges, viewport } = req.body;
    
    if (!nodes || !Array.isArray(nodes)) {
      throw new ApiError(400, 'Nodes array is required');
    }
    
    if (!edges || !Array.isArray(edges)) {
      throw new ApiError(400, 'Edges array is required');
    }
    
    const flow = await flowService.save(req.params.id, {
      nodes,
      edges,
      viewport
    });
    
    res.success(flow);
  } catch (error) {
    next(error);
  }
});

// 删除流程图
flowRouter.delete('/:id', async (req, res, next) => {
  try {
    await flowService.delete(req.params.id);
    res.deleted();
  } catch (error) {
    if (error instanceof Error && error.message === 'Flow not found') {
      next(new ApiError(404, error.message));
    } else {
      next(error);
    }
  }
});

// 更新流程图元数据
flowRouter.patch('/:id/metadata', async (req, res, next) => {
  try {
    const { name, description } = req.body;
    
    const flow = await flowService.updateMetadata(req.params.id, {
      name,
      description
    });
    
    res.success(flow);
  } catch (error) {
    if (error instanceof Error && error.message === 'Flow not found') {
      next(new ApiError(404, error.message));
    } else {
      next(error);
    }
  }
});

// 导出流程图为任务列表
flowRouter.get('/:id/export/tasks', async (req, res, next) => {
  try {
    const tasks = await flowService.exportToTasks(req.params.id);
    res.success(tasks);
  } catch (error) {
    if (error instanceof Error && error.message === 'Flow not found') {
      next(new ApiError(404, error.message));
    } else {
      next(error);
    }
  }
});